import SearchApi from './search'

export const Search = new SearchApi()

const Api = {
    Search,
}

export default Api


// WEBPACK FOOTER //
// ./application/assets/js/site/api/index.js